module.exports = __webpack_public_path__ + "5ef4e1ba074f6824d5a85f768cdf23a9.png";